import { useState, useEffect } from 'react'

/**
 * This hook is used to perform validation on the data input
 * by the user at the login form. It retuens a boolean
 * value based on the correctness of the detials
 *
 * @param parent_phone_number
 * @param phone_number
 * @param otp
 */
const useSignupValidation = (parent_phone_number, phone_number, otp) => {
    const [isOTPValid, setIsOTPValid] = useState(true)
    const [isPhoneValid, setIsPhoneValid] = useState(true)
    const [isParentPhoneValid, setIsParentPhoneValid] = useState(true)

    useEffect(() => {
        const checkPhone = () => {
            // check regex
            const regex = /^[6789]\d{9}$/

            if (
                parent_phone_number.length === 10 &&
                regex.test(parent_phone_number)
            ) {
                setIsParentPhoneValid(true)
            } else {
                setIsParentPhoneValid(false)
            }
        }

        checkPhone()
    }, [parent_phone_number])

    useEffect(() => {
        const checkPhone = () => {
            // check regex
            const regex = /^[6789]\d{9}$/

            if (phone_number.length === 10 && regex.test(phone_number)) {
                setIsPhoneValid(true)
            } else {
                setIsPhoneValid(false)
            }
        }

        checkPhone()
    }, [phone_number])

    useEffect(() => {
        const checkPhone = () => {
            // check regex
            const regex = /^[6789]\d{9}$/

            if (phone_number.length === 10 && regex.test(phone_number)) {
                setIsPhoneValid(true)
            } else {
                setIsPhoneValid(false)
            }
        }

        checkPhone()
    }, [phone_number])

    useEffect(() => {
        const checkOtp = () => {
            if (otp.length === 6) {
                setIsOTPValid(true)
            } else {
                setIsOTPValid(false)
            }
        }

        checkOtp()
    }, [otp])

    return { isParentPhoneValid, isPhoneValid, isOTPValid }
}

export default useSignupValidation
